var account = "บัญชี";
var accountSettings = "การตั้งค่าบัญชี";
var charging = "การชาร์จ";
var contactInfo = "ข้อมูลติดต่อ";
var dashboard = "แดชบอร์ด";
var home = "หน้าหลัก";
var myProducts = "สินค้าของฉัน";
var orderHistory = "ประวัติคำสั่งซื้อ";
var paymentMethod = "วิธีการชำระเงิน";
var profileSettings = "การตั้งค่าโปรไฟล์";
var referAndEarn = "แนะนำและรับเครดิต";
var signOut = "ลงชื่อออก";
var th_TH = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, th_TH as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
